export enum FpCorrelationTabs {
  CorrelationGraph = 'loadCorrCurve',
  CorrelationSpectrum = 'loadCorrSpectrum',
  Summary = 'summary',
  Comments = 'comments',
}
